import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { API_URL_PROJECTS } from "constants/api_urls";

import { AxiosContext } from "contexts/AxiosContext";
import { IProject } from "interfaces/project";
import { useContext } from "react";

export const useProjectQuery = (
  id: number | undefined | null
): UseQueryResult<IProject, unknown> => {
  const { axios } = useContext(AxiosContext)!;

  return useQuery({
    queryKey: ["project", id],
    queryFn: async () => {
      const { data } = await axios.get<IProject>(`${API_URL_PROJECTS}/${id}`);

      return data;
    },
    cacheTime: 0,
    refetchOnWindowFocus: false,
    enabled: !!id
  });
};
